import React from "react"
import {
    Stack,
    VStack,
    HStack,
    Box,
    Text,
    Link
  } from '@chakra-ui/react';

import { Link as GatsbyLink } from "gatsby"
import { EmailIcon, ExternalLinkIcon } from '@chakra-ui/icons'

import SecondaryButton from "../atoms/secondaryButton.tsx"

const offer: React.FC = () => {
    return (
        <VStack width={'full'} bgColor={'blue'} color={'white'} paddingBottom={'10px'} position={'relative'} zIndex={'20'}>
            <Stack w={'full'} maxW={'1140px'} spacing={1} py={7} px={5}>
                <HStack width={'full'} spacing={5} fontSize={'sm'}>
                    <Stack width={'48%'}>
                        <Text fontWeight={'bold'} fontSize={'4xl'}>お問い合わせ</Text>
                        <SecondaryButton ButtonName={'お問い合わせフォーム'} url={'/contact'} />
                    </Stack>
                    <Stack width={'48%'}>
                        <Box>
                            <Text fontWeight={'bold'}>本社</Text>
                            <HStack>
                            <Link href={'tel:048-928-1001'}>
                                <Text fontWeight={'bold'} fontSize={'2xl'}>048-928-1001</Text>
                            </Link>
                            <Text fontWeight={'bold'} fontSize={'md'}>(代表)</Text>
                            </HStack>
                            
                        </Box>
                        <Box>
                            <Text fontWeight={'bold'}>大利根工場</Text>
                            <HStack>
                            <Link href={'tel:0480-72-4187'}>
                                <Text fontWeight={'bold'} fontSize={'2xl'}>0480-72-4187</Text>
                            </Link>
                            </HStack>
                        </Box>
                        <Box>
                            <Text fontWeight={'bold'}>茨城工場</Text>
                            <HStack>
                            <Link href={'tel:0299-58-1155'}>
                                <Text fontWeight={'bold'} fontSize={'2xl'}>0299-58-1155</Text>
                            </Link>
                            </HStack>
                        </Box>
                        <Box>
                            <Text fontWeight={'bold'}>トータルパッケージソリューション部</Text>
                            <HStack>
                            <Link href={'tel:048-928-1008'}>
                                <Text fontWeight={'bold'} fontSize={'2xl'}>048-928-1008</Text>
                            </Link>
                            <Text fontWeight={'bold'} fontSize={'md'}>(直通)</Text>
                            </HStack>
                        </Box>
                    </Stack>
                </HStack>
            </Stack>
        </VStack>

  )
}
export default offer